import styles from './ChartLoaderView.module.scss'
import { CircularProgress } from '@mui/material'
export default function ChartLoaderView() {
  return (
    <div className={styles['loader']} >
        <CircularProgress size={60} />
        <p className={styles['loader__message']}> Calcule des données en cours... </p>
    </div>
  )
}
